import { apiRequest } from "./ApiUtility";

export async function getEnquiries(authContext, filters) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/enquiry/all`;

  return await apiRequest("post", url, authContext, filters);
}

export async function getEnquiriesById(authContext, id) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/enquiry/${id}`;

  return await apiRequest("get", url, authContext);
}

export async function createEnquiry(authContext, data) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/enquiry/create`;

  return await apiRequest("post", url, authContext, data);
}

export async function updateEnquiry(authContext, data) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/enquiry/update`;

  return await apiRequest("put", url, authContext, data);
}

export async function createEnquiryComment(authContext, data) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/enquiry/comment/create`;

  return await apiRequest("post", url, authContext, data);
}

export async function updateEnquiryComment(authContext, data) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/enquiry/comment/update`;

  return await apiRequest("put", url, authContext, data);
}

export async function deleteEnquiryComment(authContext, id) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/enquiry/comment/${id}`;

  return await apiRequest("delete", url, authContext);
}
